<template>
  <div class="terms">
    <h1 class="text-center">Terms of service</h1>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Terms of service',
  },
};
</script>

<style lang="scss" scoped></style>
